import { TabPanel, Toolbar } from "devextreme-react";
import { Item as TabPanelItem } from "devextreme-react/tab-panel";
import { Item } from "devextreme-react/toolbar";
import React from "react";
import BankInformation from "./BankInformation";
import Payroll from "./Payroll";

export default function SalaryInformation() {
  return (
    <React.Fragment>
      <Toolbar>
        <Item location={"before"}>
          <span
            style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
          >
            SALARY INFORMATION
          </span>
        </Item>
      </Toolbar>
      <TabPanel id="salaryInfoTabPanel" deferRendering={false}>
        <TabPanelItem title={"급여정보"}>
          <Payroll />
        </TabPanelItem>
        <TabPanelItem title={"은행정보"}>
          <BankInformation />
        </TabPanelItem>
      </TabPanel>
    </React.Fragment>
  );
}
